import * as _hm from './_hf';
import * as _hmFTH from './_hmFTH';
import * as _ht from './_ht';

export const grtPzForLoadI17rPs = (uz: _ht.uz, pz: {
  _31r_fst: _ht.n,
  i18r_fst?: _ht.n,
}) => {
  let _cdn = _hmFTH.vdd(uz);
  if (pz._31r_fst && pz._31r_fst != 0) _cdn += ` AND i17r_31r1f=${pz._31r_fst}`;
  if (_hm.f(pz?.i18r_fst)) {
    _cdn += ` AND _fst NOT IN (
      SELECT
        i152i17r1f
      FROM
        i152s
      WHERE
        ${_hmFTH.vdd(uz, { bVsn: false })}
        AND i152i15r1k = (
          SELECT
            _key
          FROM
            i15rs
          WHERE
            ${_hmFTH.vdd(uz)}
            AND _fst = (
              SELECT
                i18ri15r1f
              FROM
                i18rs
              WHERE
                ${_hmFTH.vdd(uz)}
                AND _fst = ${pz?.i18r_fst}
            )
        )
    )`;
  }
  return {
    tgt: 'i17rs',
    cdn: _cdn,
  };
};

export const i17z = {
  i17r: { // 設備
    v0: {
      itlz: {
        i17r_31r1f: -1,
        i17rm1100i: 0,
        i17rt1100i: 10,
        i17ra1100i: 1,
      },
      fldz: {
        i17r_31r1f: {
          pfx: '施設' 
        },
        i17rm1100i: {
          pfx: '1単位あたりの利用料',
        },
        i17rt1100i: {
          pfx: '利用料の単位',
          ls: [
            { key: 10, pfx: '回数'},
            { key: 20, pfx: '時間'},
          ]
        },
        i17ra1100i: {
          pfx: '予約可能数',
        },
      },
    },
  },
};
